module.exports = __webpack_public_path__ + "static/aboutus-bg-dc86f0156ec7c451d6765e0daa528799.png";